import MoveDownIcon from '@mui/icons-material/MoveDown';
import { ListItemIcon, MenuItem } from '@mui/material';
import { FC } from 'react';

type MoveToFolderMenuItemProps = {
  onConfirm: () => void;
};

const MoveToFolderMenuItem: FC<MoveToFolderMenuItemProps> = (props) => {
  return (
    <MenuItem onClick={props.onConfirm}>
      <ListItemIcon>{<MoveDownIcon fontSize='small' />}</ListItemIcon>
      Move to folder
    </MenuItem>
  );
};

export default MoveToFolderMenuItem;
